import { Materials } from "../types/materials";
import {  DocumentTag1 as DocumentTag , PipeSize } from "../types/index";


export const materialsList: Materials[] = [
    // Pipe Materials
    {
      id: '1',
      category: 'Pipe',
      pipeId: 'pipe-0',
      status: 'Available',
      pipeNRI: 'NRI-P001',
      pipeNo: 'PIPE-2024-001',
      heatNumber: 'HN24P001',
      length: 12.5,
      outerDiameter: 12.75,
      wallThickness: 0.5,
      documents: [
        { id: 'doc1', file: new File([], 'MTR-Certificate-001.pdf'), tags: ['Certificate', 'MTR'] },
        { id: 'doc2', file: new File([], 'Dimensional-Report-001.pdf'), tags: ['Report', 'Dimensional'] }
      ]
    },
    {
      id: '2',
      category: 'Pipe',
      pipeId: 'pipe-0',
      status: 'Consumed',
      assemblyNumber: 'Assy-001',
      pipeNRI: 'NRI-P002',
      pipeNo: 'PIPE-2024-002',
      heatNumber: 'HN24P002',
      length: 12.5,
      outerDiameter: 12.75,
      wallThickness: 0.5,
      documents: [
        { id: 'doc3', file: new File([], 'MTR-Certificate-002.pdf'), tags: ['Certificate', 'MTR'] }
      ]
    },
    {
      id: '3',
      category: 'Pipe',
      pipeId: 'pipe-1',
      status: 'Available',
      pipeNRI: 'NRI-P003',
      pipeNo: 'PIPE-2024-003',
      heatNumber: 'HN24P003',
      length: 12.5,
      outerDiameter: 16.0,
      wallThickness: 0.75,
      documents: [
        { id: 'doc4', file: new File([], 'MTR-Certificate-003.pdf'), tags: ['Certificate', 'MTR'] },
        { id: 'doc5', file: new File([], 'Inspection-Report-001.pdf'), tags: ['Report', 'Inspection'] }
      ]
    },

    // Forge Materials
    {
      id: '4',
      category: 'Forge',
      pipeId: 'pipe-0',
      status: 'Available',
      forgeNRI: 'NRI-F001',
      forgeOrderNumber: 'FO-2024-001',
      forgeSerialNumber: 'FSN-001',
      forgeHeatNumber: 'HN24F001',
      documents: [
        { id: 'doc6', file: new File([], 'Forge-Certificate-001.pdf'), tags: ['Certificate'] },
        { id: 'doc7', file: new File([], 'Forge-Drawing-001.pdf'), tags: ['Drawing'] }
      ]
    },
    {
      id: '5',
      category: 'Forge',
      pipeId: 'pipe-0',
      status: 'Consumed',
      assemblyNumber: 'Assy-002',
      forgeNRI: 'NRI-F002',
      forgeOrderNumber: 'FO-2024-002',
      forgeSerialNumber: 'FSN-002',
      forgeHeatNumber: 'HN24F002',
      documents: [
        { id: 'doc8', file: new File([], 'Forge-Certificate-002.pdf'), tags: ['Certificate'] }
      ]
    },
    {
      id: '6',
      category: 'Forge',
      pipeId: 'pipe-1',
      status: 'Available',
      forgeNRI: 'NRI-F003',
      forgeOrderNumber: 'FO-2024-003',
      forgeSerialNumber: 'FSN-003',
      forgeHeatNumber: 'HN24F003',
      documents: [
        { id: 'doc9', file: new File([], 'Forge-Certificate-003.pdf'), tags: ['Certificate'] },
        { id: 'doc10', file: new File([], 'Quality-Report-001.pdf'), tags: ['Report', 'Quality'] }
      ]
    },

    // Gas Materials
    {
      id: '7',
      category: 'Gas',
      pipeId: 'pipe-0',
      status: 'Available',
      gasSerialNumber: 'GAS-2024-001'
    },
    {
      id: '8',
      category: 'Gas',
      pipeId: 'pipe-0',
      status: 'Consumed',
      gasSerialNumber: 'GAS-2024-002',
      assemblyNumbers: ['Assy-001', 'Assy-002']
    },
    {
      id: '9',
      category: 'Gas',
      pipeId: 'pipe-1',
      status: 'Consumed',
      gasSerialNumber: 'GAS-2024-003',
      assemblyNumbers: ['Assy-003']
    },

    // Wire Lot Materials
    {
      id: '10',
      category: 'Wire Lot',
      pipeId: 'pipe-0',
      status: 'Available',
      lotNumber: 'WL-2024-001'
    },
    {
      id: '11',
      category: 'Wire Lot',
      pipeId: 'pipe-0',
      status: 'Consumed',
      lotNumber: 'WL-2024-002',
      assemblyNumbers: ['Assy-001', 'Assy-002']
    },
    {
      id: '12',
      category: 'Wire Lot',
      pipeId: 'pipe-1',
      status: 'Available',
      lotNumber: 'WL-2024-003'
    }
  ];
  export const documentTags: DocumentTag[] = [
    { id: '1', name: 'Certificate' },
    { id: '2', name: 'MTR' },
    { id: '3', name: 'Drawing' },
    { id: '4', name: 'Report' },
    { id: '5', name: 'Dimensional' },
    { id: '6', name: 'Inspection' },
    { id: '7', name: 'Quality' }
  ];
  export const pipeSizes: PipeSize[] = [
    {
      size: '12.75',
      wallThickness: '0.5',
      buckleArrestors: '2',
      numberOfPipes: '10',
      pipeLength: '12.5',
      numberOfForges: '4',
      outputAssemblyLength: '120',
      manufacturer: 'Manufacturer A'
    },
    {
      size: '16.0',
      wallThickness: '0.75',
      buckleArrestors: '2',
      numberOfPipes: '8',
      pipeLength: '12.5',
      numberOfForges: '4',
      outputAssemblyLength: '96',
      manufacturer: 'Manufacturer B'
    }
  ];